export const ADMIN_COLLECTION_CREATE_REQUEST = "ADMIN_COLLECTION_CREATE_REQUEST";
export const ADMIN_COLLECTION_CREATE_SUCCESS = "ADMIN_COLLECTION_CREATE_SUCCESS";
export const ADMIN_COLLECTION_CREATE_FAIL = "ADMIN_COLLECTION_CREATE_FAIL";
export const ADMIN_COLLECTION_CREATE_RESET = "ADMIN_COLLECTION_CREATE_RESET";

export const ADMIN_COLLECTION_LIST_REQUEST = "ADMIN_COLLECTION_LIST_REQUEST";
export const ADMIN_COLLECTION_LIST_SUCCESS = "ADMIN_COLLECTION_LIST_SUCCESS";
export const ADMIN_COLLECTION_LIST_FAIL = "ADMIN_COLLECTION_LIST_FAIL";

export const ADMIN_COLLECTION_SEARCH_REQUEST = "ADMIN_COLLECTION_SEARCH_REQUEST";
export const ADMIN_COLLECTION_SEARCH_SUCCESS = "ADMIN_COLLECTION_SEARCH_SUCCESS";
export const ADMIN_COLLECTION_SEARCH_FAIL = "ADMIN_COLLECTION_SEARCH_FAIL";

export const ADMIN_COLLECTION_VIEW_REQUEST = "ADMIN_COLLECTION_VIEW_REQUEST";
export const ADMIN_COLLECTION_VIEW_SUCCESS = "ADMIN_COLLECTION_VIEW_SUCCESS";
export const ADMIN_COLLECTION_VIEW_FAIL = "ADMIN_COLLECTION_VIEW_FAIL";

export const ADMIN_COLLECTION_DELETE_REQUEST = "ADMIN_COLLECTION_DELETE_REQUEST";
export const ADMIN_COLLECTION_DELETE_SUCCESS = "ADMIN_COLLECTION_DELETE_SUCCESS";
export const ADMIN_COLLECTION_DELETE_FAIL = "ADMIN_COLLECTION_DELETE_FAIL";

export const ADMIN_COLLECTION_UPDATE_REQUEST = "ADMIN_COLLECTION_UPDATE_REQUEST";
export const ADMIN_COLLECTION_UPDATE_SUCCESS = "ADMIN_COLLECTION_UPDATE_SUCCESS";
export const ADMIN_COLLECTION_UPDATE_FAIL = "ADMIN_COLLECTION_UPDATE_FAIL";
export const ADMIN_COLLECTION_UPDATE_RESET = "ADMIN_COLLECTION_UPDATE_RESET";

export const ADMIN_ADD_PRODUCT_COLLECTION_REQUEST = "ADMIN_ADD_PRODUCT_COLLECTION_REQUEST";
export const ADMIN_ADD_PRODUCT_COLLECTION_SUCCESS = "ADMIN_ADD_PRODUCT_COLLECTION_SUCCESS";
export const ADMIN_ADD_PRODUCT_COLLECTION_FAIL = "ADMIN_ADD_PRODUCT_COLLECTION_FAIL";

export const ADMIN_ADD_PRODUCTS_COLLECTION_REQUEST = "ADMIN_ADD_PRODUCTS_COLLECTION_REQUEST";
export const ADMIN_ADD_PRODUCTS_COLLECTION_SUCCESS = "ADMIN_ADD_PRODUCTS_COLLECTION_SUCCESS";
export const ADMIN_ADD_PRODUCTS_COLLECTION_FAIL = "ADMIN_ADD_PRODUCTS_COLLECTION_FAIL";

export const ADMIN_ADD_PRODUCTSIDS_COLLECTION_REQUEST = "ADMIN_ADD_PRODUCTSIDS_COLLECTION_REQUEST";
export const ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS = "ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS";
export const ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS_RESET =
  "ADMIN_ADD_PRODUCTSIDS_COLLECTION_SUCCESS_RESET";
export const ADMIN_ADD_PRODUCTSIDS_COLLECTION_FAIL = "ADMIN_ADD_PRODUCTSIDS_COLLECTION_FAIL";

export const ADMIN_REMOVE_PRODUCT_COLLECTION_REQUEST = "ADMIN_REMOVE_PRODUCT_COLLECTION_REQUEST";
export const ADMIN_REMOVE_PRODUCT_COLLECTION_SUCCESS = "ADMIN_REMOVE_PRODUCT_COLLECTION_SUCCESS";
export const ADMIN_REMOVE_PRODUCT_COLLECTION_FAIL = "ADMIN_REMOVE_PRODUCT_COLLECTION_FAIL";

export const ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_REQUEST =
  "ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_REQUEST";
export const ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_SUCCESS =
  "ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_SUCCESS";
export const ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_FAIL = "ADMIN_REMOVE_ALL_PRODUCT_COLLECTION_FAIL";

export const ADMIN_REMOVE_PRODUCTS_COLLECTION_REQUEST = "ADMIN_REMOVE_PRODUCTS_COLLECTION_REQUEST";
export const ADMIN_REMOVE_PRODUCTS_COLLECTION_SUCCESS = "ADMIN_REMOVE_PRODUCTS_COLLECTION_SUCCESS";
export const ADMIN_REMOVE_PRODUCTS_COLLECTION_FAIL = "ADMIN_REMOVE_PRODUCTS_COLLECTION_FAIL";
